import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WarningWindowComponent } from './warning-window/warning-window.component';

@NgModule({
  declarations: [WarningWindowComponent],
  imports: [CommonModule],
  exports: [WarningWindowComponent]
})
export class ReportingUiModule {}
